<template>
  <div
    class="c-input"
    :class="{'u-w680': !isHorizontal, 'is-error': errorMessage !== '' }"
  >
    <div class="c-input__title" :class="{'u-w190': isHorizontal}">{{ title }}</div>
    <div class="c-input__text">{{ description }}</div>
    <input
      v-model="dataValue"
      :name="inputName"
      class="c-input__item"
      :class="{'u-w680': isHorizontal}"
      type="text"
      :placeholder="placeholder"
      :readonly="isReadonly"
      :style="isReadonly ? 'background-color: #f6f6f6;' : ''"
    />
    <div class="c-error c-error--balloon" :class="{'is-active': errorMessage !== '' }">
      <div class="c-error__text">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputName: String,
    title: String,
    description: String,
    data: [String, Number],
    placeholder: String,
    errorMessage: {
      type: String,
      default: ''
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    isReadonly: {
      type: Boolean,
      default: false
    }
  },
  emits: ["value-changed"],
  data() {
    return {
      dataValue: this.data
    }
  },
  updated: function () {
    const self = this;
    this.$nextTick(function () {
      this.$emit("value-changed", self.dataValue);
    });
  },
  methods: {
    changeValue: function(value) {
      this.dataValue = value;
    }
  }
}
</script>